/***
 * 图片收集题: 相关配置
 */
// import { nanoid } from 'nanoid';

export default {
  reporType: 100184,
  //中文
  zh: {
    placeholder: '请上传图片',
    uploadTip: '支持格式：jpg、jpeg、png、bmp，最多上传3张，每个张图片大小不超过4M'
  },
  // 英文
  en: {
    placeholder: 'Please upload the image',
    uploadTip: 'Supported formats: jpg、jpeg、png、bmp. Maximum of 3 images can be uploaded, with each image size not exceeding 4MB'
  },
  // 创建一个隐私协议项
  create(lang = 'zh') {
    return {
      label: '图片收集',
      subject: '图片收集',
      required: true, //是否必填
      is_must: 1,
      options: {
        placeholder: '请上传图片',
      },
      items: [],
      type: 14,
      reporType: this.reporType,
      reqType: 14,
      default_type: 14,
      system_type: 14
    };
  }
};
